<tapestry-icon-button
    [matMenuTriggerFor]="menu.matMenu"
    [iconName]="'blackhat_laptop_bold'"
    class="dropdown-button"
    [altText]="TR.key('globalnav.developerMenu-altText')"
>
</tapestry-icon-button>
<tapestry-dropdown
    #menu
    [optionsList]="developerDropDownItems"
    (menuOptionSelected)="nav.menuAction($event)"
></tapestry-dropdown>
